import { useMutation } from "@tanstack/react-query";
import { setPendingPaymentToStorage } from "@src/shared/lib/paymentStorage";
import { createTariff } from "@src/entities/tariffs/api/request/createTariff";
import { tariffsStore } from "../../store/tariffsStore";
import { useNotificationStore } from "@src/shared/components/Notification";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";

export const useCreateTariff = () => {
  const { showAlert } = useNotificationStore();

  return useMutation({
    mutationFn: createTariff,
    onSuccess: (response) => {
      tariffsStore.getState().setLinkCurrentTariff(response);

      const currentUserId = useUserInfoMeStore.getState().user?.id;

      if (response?.order_id && currentUserId) {
        setPendingPaymentToStorage({
          orderId: response.order_id,
          userId: currentUserId,
          createdAt: Date.now(),
        });
      }
    },
    onError: (error: Error) => {
      showAlert(error.message, "error");
    },
  });
};
